import { useCallback, useState } from 'react'
import styled from '@emotion/styled'
import Breadcrumb from '../../../components/common/Breadcrumb'
import Text from '../../../components/common/Text'
import IconUser from '../../../assets/images/icons-user.svg'
import IconUserGroup from '../../../assets/images/icons-user-group-green-32-px.svg'
import IconTrip from '../../../assets/images/icons-trip-48-px.svg'
import IconPDF from '../../../assets/images/icon-pdf@3x.png'
import IconEye from '../../../assets/images/icon-eye32@3x.png'
import Loading from '../../../components/common/Loading'
import Button from '../../../components/common/Button'
import { mobile, useScreen } from '../../../utils/responsive-helper'
import BenefitsCard from './BenefitsCard'
import Image from '../../../components/common/Image'
import SelfBenefits from './SelfBenefits'
import RelativeBenefits from './RelativeBenefits'
import LifeStyleBenefits from './LifeStyleBenefits'
import SummaryExchangeBenefits from './SummaryExchangeBenefits'
import { useHistory } from 'react-router'
import { useTranslation } from 'react-i18next'
import { enrollmentInsuranceFamily, enrollmentLeave } from '../../../constant/path'
import { FONT_BLACK } from '../../../constant/colors'
import { useGetUser } from '../../../services/user/user-query'
import {
  useGetAllSelectedBenefits,
  useGetEnrollmentPeriod,
} from '../../../services/enrollment/enrollment-query'
import dayjs from 'dayjs'
import { pullAt } from 'lodash'
import {
  getShowModalDownloadInsuranceDetail,
  setShowModalDownloadInsuranceDetail,
  useCanEditable,
} from '../../../utils/helper'
import { Modal } from '../../../components/common/Modal'
import { useVisibility } from '../../../utils/custom-hook'
import Checkbox from 'antd/lib/checkbox/Checkbox'
import { Footer } from '../ModalAcceptPrivacy'
import { useEffect } from 'react'
import { useGetEnrollmentYear } from '..'

const Layout = styled.div`
  margin-bottom: 40px;
`

const BreadcrumbLayout = styled.div`
  margin-top: 24px;
`
const Row = styled.div`
  display: flex;
  flex-flow: row;
`

const PaddingTextTop = styled.div`
  padding-top: 16px;
  padding-bottom: 16px;
  align-self: center;
`

const LayoutTitle = styled(Row)`
  justify-content: center;
  text-align: center;
  margin-top: 24px;
  margin-bottom: 27px;
`

const LayoutContentModal = styled.div`
  width: 500px;
  padding: 12px;
  ${mobile} {
    width: auto;
  }
`

const FooterModal = styled(Footer)`
  .check-box {
    margin-bottom: 0px;
  }
`

const Benefits = () => {
  const { t } = useTranslation()
  const { isMobile } = useScreen()
  const history = useHistory()
  const canEditable = useCanEditable()
  const { enrollmentYear } = useGetEnrollmentYear()

  const { data: user } = useGetUser()
  const { data: peroid } = useGetEnrollmentPeriod()
  const { benefitYearId, endDate } = peroid || {}
  const { data: selectedBenefits, isLoading } = useGetAllSelectedBenefits(benefitYearId)
  const {
    selfBenefitWrapper: selfBenefits,
    relativesWrapper: relativeBenefits,
    preSelectedClaimsWrapper2: lifeStyleBenefits,
    totalAvailableCoins,
    totalUsedCoins,
    totalEarnedCoins,
    totalRemainingCoins,
  } = selectedBenefits || {}

  // const age = user?.age ? `${user.age}` : '-'
  // const name = `${user?.firstName} ${user?.lastName} (${age})`

  // // const [initialModal, setInitialModal] = useState(true)
  // const [modalInsuranceDetail, setModaInsuranceDetail] = useVisibility()
  // const [hideModalInsuranceDetailAgain, setHideModalInsuranceDetailAgain] = useState(
  //   getShowModalDownloadInsuranceDetail() === 'hide' ? true : false,
  // )

  // const onClickToInsuranceFamily = useCallback(() => {
  //   if (benefitYearId) {
  //     history.push(
  //       enrollmentInsuranceFamily({
  //         routeParam: { benefitYearId },
  //       }),
  //     )
  //   }
  // }, [benefitYearId, history])

  // const onClickToExchangeLeave = useCallback(() => {
  //   if (benefitYearId) {
  //     history.push(enrollmentLeave({ routeParam: { benefitYearId } }))
  //   }
  // }, [benefitYearId, history])

  // useEffect(() => {
  //   if (
  //     getShowModalDownloadInsuranceDetail() === 'show' ||
  //     !getShowModalDownloadInsuranceDetail()
  //   ) {
  //     setModaInsuranceDetail.show()
  //   }
  // }, [])

  // const onCloseModalInsuranceDetail = useCallback(() => {
  //   setModaInsuranceDetail.hide()
  // }, [setModaInsuranceDetail])

  // const onClickDownloadInsuranceDetail = useCallback(() => {
  //   window.open(
  //     'https://drive.google.com/file/d/1bftd8hWkr5_W9YP4PMaUDTsZ9yItWanw/view?usp=sharing',
  //   )
  // }, [])

  return (
    <Layout>
      {/* <Modal visible={modalInsuranceDetail} onCancel={onCloseModalInsuranceDetail} hideFooter>
        <LayoutContentModal>
          <Text style={{ textAlign: 'center' }}>
            พนักงานสามารถตรวจสอบข้อมูลและรายละเอียดกรมธรรม์และค่าเบี้ยประกันของแผนประกันสุขภาพและประกันอุบัติเหตุสำหรับตนเอง/ครอบครัวประจำปี
            {enrollmentYear}ได้โดยคลิกที่ไฟล์ PDF ด้านล่าง
          </Text>
          <Row style={{ marginTop: '36px', marginBottom: '18px' }}>
            <Image
              src={IconPDF}
              width={73}
              height={73}
              style={{ margin: 'auto', cursor: 'pointer' }}
              onClick={onClickDownloadInsuranceDetail}
            />
          </Row>
          <Text style={{ textAlign: 'center', marginBottom: '36px' }}>
            แผนประกันสุขภาพและอุบัติเหตุประจำปี {enrollmentYear}
          </Text>
          <FooterModal>
            <Checkbox
              className="check-box"
              onChange={(v) => {
                var isHide = !hideModalInsuranceDetailAgain
                setHideModalInsuranceDetailAgain((prev) => !prev)
                if (isHide) {
                  setShowModalDownloadInsuranceDetail('hide')
                } else {
                  setShowModalDownloadInsuranceDetail('show')
                }
              }}
              defaultChecked={hideModalInsuranceDetailAgain}
              checked={hideModalInsuranceDetailAgain}
              autoFocus={true}
            >
              <Text size={18} color={FONT_BLACK}>
                ไม่ต้องแสดงอีก
              </Text>
            </Checkbox>
          </FooterModal>
        </LayoutContentModal>
      </Modal> */}
      {!isMobile && (
        <BreadcrumbLayout>
          <Breadcrumb
            overide={(paths) => {
              // paths.unshift({ label: 'Home', path: '/' })
              paths[0].label = t('ปรับเปลี่ยนสวัสดิการ')
              paths[1].label = t(`ดูสวัสดิการปี ${enrollmentYear}`)
              paths[2].label = t(`สวัสดิการปี ${enrollmentYear} ของฉัน`)
              pullAt(paths, 3)
              return paths
            }}
          />
        </BreadcrumbLayout>
      )}
      <LayoutTitle>
        <Text size={28} type="Bold" color={FONT_BLACK}>
          สวัสดิการบริษัทปี {enrollmentYear} ของฉัน
        </Text>
      </LayoutTitle>
      <Row>
        <Text size={26} type="Bold" color={FONT_BLACK}>
          สวัสดิการปี {enrollmentYear} ที่เลือกแล้ว
        </Text>
      </Row>
      <Row style={{ justifyContent: 'space-between' }}>
        <PaddingTextTop>
          <Text size={18}>
            ในปี {enrollmentYear} คุณจะได้สวัสดิการด้านล่างนี้เลยคุณยังสามารถแก้ไขได้อยู่
          </Text>
        </PaddingTextTop>
        {/* <PaddingTextTop>
          <div
            style={{
              height: '18px',
              borderColor: 'transparent',
              backgroundColor: 'transparent',
              cursor: 'pointer',
            }}
            onClick={setModaInsuranceDetail.show}
          >
            <Row>
              <Image
                src={IconEye}
                width={20}
                height={15}
                style={{ margin: 'auto', marginRight: '8px' }}
              />
              <div hidden={isMobile}>
                <Text size={18}>ดูรายละเอียดกรมธรรม์</Text>
              </div>
            </Row>
          </div>
        </PaddingTextTop> */}
      </Row>
      {/* <BenefitsCard icon={IconUser} title={'ประกันตัวเอง'} desc={name}>
        <Loading loading={isLoading}>
          {selfBenefits && <SelfBenefits selfBenefits={selfBenefits} canEditable={canEditable} />}
        </Loading>
      </BenefitsCard> */}
      {/* {relativeBenefits && (
        <Loading loading={isLoading}>
          <RelativeBenefits relativeBenefits={relativeBenefits} canEditable={canEditable} />
        </Loading>
        // <BenefitsCard>
        //   <Loading loading={isLoading}>
        //     <RelativeBenefits relativeBenefits={relativeBenefits} />
        //   </Loading>
        // </BenefitsCard>
      )} */}
      {/* {canEditable === true && (
        <BenefitsCard
          icon={IconUserGroup}
          title={'ประกันสุขภาพเพิ่มเติมให้ครอบครัว'}
          desc={'สำหรับ คู่สมรส บุตร บิดา มารดา เท่านั้น'}
          isDesc={true}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              paddingTop: 16,
            }}
          >
            <Button onClick={onClickToInsuranceFamily}>+แก้ไขประกันให้ครอบครัว</Button>
          </div>
        </BenefitsCard>
      )} */}
      <BenefitsCard
        icon={IconTrip}
        title={'สวัสดิการเพื่อไลฟ์สไตล์'}
        desc={'คุณสามารถแลกสวัสดิการแบบเลือกเองได้'}
        isDesc={true}
      >
        <Loading loading={isLoading}>
          {lifeStyleBenefits && (
            <LifeStyleBenefits lifeStyleBenefits={lifeStyleBenefits} canEditable={canEditable} />
          )}
        </Loading>
      </BenefitsCard>
      {/* <BenefitsCard
        icon={IconTrade}
        title={'แลกเป็นคะแนน '}
        desc={'คุณสามารถแลกวันลาเป็นคะแนนได้ '}
      >
        <BenefitsCategory icon={IconEnroll} title={'แลกวันลา'}>
          <BenefitsCategoryList>
            {canEditable === true && <Button onClick={onClickToExchangeLeave}>แลกวันลา</Button>}
          </BenefitsCategoryList>
        </BenefitsCategory>
      </BenefitsCard>
      <Row style={{ marginBottom: 16 }}>
        <Image src={IconCoinCorrect} width={32} height={32} />
        <Text size={24} type={'Bold'} style={{ marginLeft: 16 }}>
          แลกเป็นคะแนน{' '}
        </Text>
      </Row> */}
      <SummaryExchangeBenefits
        totalAvailableCoins={totalAvailableCoins}
        totalUsedCoins={totalUsedCoins}
        totalEarnedCoins={totalEarnedCoins}
        totalRemainingCoins={totalRemainingCoins}
      />

      {endDate ? (
        <Row
          style={{
            width: '100%',
            justifyContent: 'center',
            marginTop: 16,
            // marginBottom: 40,
          }}
        >
          <Text size={20} color={FONT_BLACK}>
            {`(คุณยังสามารถแก้ไขได้ถึง วันที่ ${dayjs(Number(endDate))
              .add(543, 'year')
              .format('DD MMM YYYY')})`}
          </Text>
        </Row>
      ) : null}
    </Layout>
  )
}

// type BenefitsCategoryListProp = {
//   children: ReactNode
// }
// export const BenefitsCategoryList = (props: BenefitsCategoryListProp) => {
//   const { children } = props
//   return (
//     <>
//       <div
//         style={{
//           minHeight: 75,
//           borderStyle: 'solid',
//           borderColor: '#f5f7fa',
//           borderWidth: '0 1px 1px 1px',
//           padding: 24,
//         }}
//       >
//         <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
//           <Text size={22} type={'Bold'}>
//             เสียชีวิตรับเงิน 12 เท่า (แผน A)
//           </Text>

//           <Text size={22} type={'Bold'} color={INPUT_ERROR} style={{ whiteSpace: 'nowrap' }}>
//             -200
//           </Text>
//         </div>
//       </div>

//       <div
//         style={{
//           minHeight: 109,
//           borderStyle: 'solid',
//           borderColor: '#f5f7fa',
//           borderWidth: '0 1px 1px 1px',
//           padding: 32,
//         }}
//       >
//         <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
//           {children}
//         </div>
//       </div>
//     </>
//   )
// }

export default Benefits
